/** Ignore identical deep-link URLs re-emitted within this window (ms). */
export const DEEP_LINK_DEDUPE_WINDOW_MS = 3_000;

let lastHandled: { url: string; at: number } | null = null;
let launchUrlFetchStarted = false;

export function normalizeDeepLinkUrl(url: string): string {
  try {
    const parsed = new URL(url);
    const pathname =
      parsed.pathname.length > 1 && parsed.pathname.endsWith('/')
        ? parsed.pathname.slice(0, -1)
        : parsed.pathname;
    return `${parsed.protocol}//${parsed.host}${pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return url.trim();
  }
}

export function shouldProcessDeepLink(url: string, now = Date.now()): boolean {
  const normalized = normalizeDeepLinkUrl(url);

  if (
    lastHandled &&
    lastHandled.url === normalized &&
    now - lastHandled.at < DEEP_LINK_DEDUPE_WINDOW_MS
  ) {
    return false;
  }

  return true;
}

/** Claim a URL before async handling so concurrent emits dedupe correctly. */
export function claimDeepLink(url: string, now = Date.now()): boolean {
  if (!shouldProcessDeepLink(url, now)) {
    return false;
  }

  lastHandled = { url: normalizeDeepLinkUrl(url), at: now };
  return true;
}

/**
 * Cold-start launch URL is fetched at most once per JS session (survives Strict
 * Mode remounts). Returns false when a prior mount already started the fetch.
 */
export function markLaunchUrlFetchStarted(): boolean {
  if (launchUrlFetchStarted) {
    return false;
  }
  launchUrlFetchStarted = true;
  return true;
}

/** Test helper — resets module state between unit tests. */
export function resetDeepLinkDedupeStateForTests(): void {
  lastHandled = null;
  launchUrlFetchStarted = false;
}
